import React, { useCallback } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import api from '@/api/knowledgeBase.service';
import { permissionsActions } from '@/state/permissions';
import { AsyncAutoComplete, ButtonsCollection, FormsCollection, ModalWindow } from '@/ui-kit';
import { useKnowledgeBaseContext } from '@/views/knowledgeBase/context/useKnowledgeBaseContext';
import './style.sass';


const AUTOCOMPLETE_LIMIT = 10;

export const CreateCategoryModal = ({ isOpen, setIsOpenedModal }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { refreshCategories } = useKnowledgeBaseContext();


  const closeModal = useCallback(() => setIsOpenedModal(false), [setIsOpenedModal]);

  const {
    control, reset, handleSubmit, formState: { errors },
  } = useForm({
    defaultValues: {
      description: '',
      roles: []
    }
  });

  const getRolesAutocompleteAction = useCallback((object, callback) => {
    dispatch(permissionsActions.getRolesAutocompleteRequest(object, callback));
  }, []);

  const getAutocompleteHandler = (fieldValue, callback) => {
    getRolesAutocompleteAction({
      q: fieldValue,
      limit: AUTOCOMPLETE_LIMIT,
    }, {
      callbacks: {
        success: ({ roles: rolesData }) => {
          const rolesResult = rolesData.map((role) => ({label: role.name, value: role.id}));
          callback(rolesResult);
        },
      },
    });
  };


  const onCloseModal = () => {
    reset();
    closeModal();
  };

  const onSubmit = async (data) => {
    try {
      await api.createKnowledgeBaseCategory({
        description: data.description,
        roleIds: data.roles.map(role => role.value)
      });

      refreshCategories();

      onCloseModal();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ModalWindow
      isOpen={isOpen}
      onClose={onCloseModal}
      modalName="createCategoryModal"
      title="Create category"
      className="modal-window__create-category"
    >
      <FormsCollection.FormWrapper handleSubmit={handleSubmit(onSubmit)} className="invite-channel-members">
        <div className="create-category__row">
          <Controller
            name="description"
            control={control}
            render={({ onBlur, value, field, onChange, error }) => (
              <FormsCollection.Input
                placeholderJump="Category title"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                touched
                error={error}
                {...field}
              />
            )}
          />
        </div>
        <div className="create-category__row">
          <Controller
            name="roles"
            control={control}
            render={({
              onBlur, value, touched, field,
            }) => (
              <AsyncAutoComplete
              isMulti
              value={value}
              error={errors.role_id?.message}
              touched={touched}
              onBlur={onBlur}
              name="roles"
              placeholder={t('Roles')}
              loadOptions={getAutocompleteHandler}
              {...field}
                />
            )}
          />
        </div>
        <div className="button-group">
          <ButtonsCollection.ButtonBrill
            type="submit"
            className="button--md create-category__button-save button-brill--fill"
          >
            {t('Save')}
          </ButtonsCollection.ButtonBrill>
        </div>
      </FormsCollection.FormWrapper>
    </ModalWindow>
  )
}
